module.exports = __webpack_public_path__ + "img/meta_categories.df46da01.png";